export const FileName = $localize`fileName`;
export const UploadedOn = $localize`uploadedOn`;
export const displayedColumns = [`fileName`, `uploadedOn`];
